// Coalesce visible record reads, never cache completed account data. Each batch
// is isolated by the caller's opaque login/policy scope; no tokens enter keys.
export function createArtworkReadBatch(readBatch,{delay=0,limit=100}={}) {
  const pending=new Map()
  function flush(scope) {
    const group=pending.get(scope);pending.delete(scope)
    if(!group)return
    const entries=[...group.entries()].filter(([,waiters])=>waiters.some(waiter=>!waiter.signal?.aborted))
    for(let offset=0;offset<entries.length;offset+=limit){
      const slice=entries.slice(offset,offset+limit),ids=slice.map(([id])=>id)
      Promise.resolve().then(()=>readBatch([...ids])).then(data=>{
        if(!data?.ok||data.complete!==true||!['ready','conflict'].includes(data.status)||!Array.isArray(data.rows)||!Array.isArray(data.conflicts)||!Array.isArray(data.championshipIds)||data.championshipIds.length!==ids.length||new Set(data.championshipIds.map(String)).size!==ids.length||ids.some(id=>!data.championshipIds.map(String).includes(id))||[...data.rows,...data.conflicts].some(row=>!ids.includes(String(row.championshipId))))throw Error('The artwork batch read is incomplete. Refresh; do not recreate saved artwork.')
        for(const [id,waiters] of slice){
          const rows=data.rows.filter(row=>String(row.championshipId)===id),conflicts=(data.conflicts||[]).filter(row=>String(row.championshipId)===id)
          const result={...data,rows,conflicts,status:conflicts.length?'conflict':'ready',counts:null,championshipIds:[id]}
          for(const waiter of waiters)if(!waiter.signal?.aborted)waiter.resolve(result)
        }
      }).catch(error=>{for(const [,waiters] of slice)for(const waiter of waiters)if(!waiter.signal?.aborted)waiter.reject(error)})
    }
  }
  return (id,{scope,signal}={})=>new Promise((resolve,reject)=>{
    if(signal?.aborted){reject(new DOMException('Read cancelled','AbortError'));return}
    if(!pending.has(scope)){pending.set(scope,new Map());setTimeout(()=>flush(scope),delay)}
    const group=pending.get(scope),key=String(id)
    if(!group.has(key))group.set(key,[])
    group.get(key).push({resolve,reject,signal})
    signal?.addEventListener('abort',()=>reject(new DOMException('Read cancelled','AbortError')),{once:true})
  })
}
